export const environment = {
  production: false,
  settings: {
    clientId: 'nessy.support.sales.client',
    authAuthority: 'https://nessy-id-dev.nessy.com',
  },
  api: {
    hub: 'https://hub-api-dev.nessy.com',
    id: 'https://nessy-id-dev.nessy.com/api/',
  },
  identity: {
    ghostUrl: `https://nessy-id-dev.nessy.com/support/ghostlogin`,
  },
  wordpress: {
    account: 'https://nessyshopdev.wpengine.com/<locale>/wp-admin/user-edit.php?user_id=<wordpress_id>',
    orders: 'https://nessyshopdev.wpengine.com/<locale>/wp-admin/post.php?post=<order-id>&action=edit'
  }
};
